import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import axios from "axios";

function authConfig() {
  return {
    headers: {
      Authorization: `Bearer ${tokenDecrypted()}`,
    },
  };
}

export async function GetEmploymentAccountsAPI() {
  try {
    const response = await axios.get(
      `${URL_API}/employment/accounts`,
      authConfig()
    );
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function GetAdminAccountsAPI(companyId) {
  try {
    const response = await axios.get(`${URL_API}/admin/accounts`, authConfig());
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function GetCompanyAccountsAPI() {
  try {
    const response = await axios.get(
      `${URL_API}/company/accounts`,
      authConfig()
    );
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function UpdateEmploymentPasswordAPI(id, password) {
  try {
    const response = await axios.put(
      `${URL_API}/employment/reset/${id}`,
      { password },
      authConfig()
    );
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function UpdateAdminPasswordAPI(id, password) {
  try {
    const response = await axios.put(
      `${URL_API}/admin/${id}/password`,
      { password },
      authConfig()
    );
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function UpdateCompanyPasswordAPI(id, password) {
  try {
    const response = await axios.put(
      `${URL_API}/company/${id}/password`,
      { password },
      authConfig()
    );
    return response;
  } catch (error) {
    return error.response;
  }
}
